var map = {
	"./ACB.svg": "effa",
	"./BANVIET.svg": "dfd7",
	"./BIDV.svg": "0045",
	"./BVBANK.svg": "b2be",
	"./CITIBANK.svg": "fd7b",
	"./EXIMBANK.svg": "6509",
	"./FECREDIT.svg": "c0ee",
	"./HDBANK.svg": "11a0",
	"./HOMECREDIT.svg": "fcb1",
	"./HSBC.svg": "a2cb",
	"./KIENLONGBANK.svg": "91bf",
	"./LIENVIETPOSTBANK.svg": "e3fe",
	"./LOTTE_FINANCE.svg": "c89f",
	"./MARITIMEBANK.svg": "43d0",
	"./MBBANK.svg": "bf15",
	"./MCREDIT.svg": "635a",
	"./MIRAEASSET.svg": "073d",
	"./NAMA.svg": "e8df",
	"./NCB.svg": "4561",
	"./OCB.svg": "30b4",
	"./PVCOMBANK.svg": "3e95",
	"./SACOMBANK.svg": "6817",
	"./SCB.svg": "852d",
	"./SEABANK.svg": "4649",
	"./SHB.svg": "5ee5",
	"./SHBVN.svg": "a161",
	"./SHINHANFINANCE.svg": "7c66",
	"./STANDARDCHARTERED.svg": "8543",
	"./TECHCOMBANK.svg": "eb3d",
	"./TPBANK.svg": "e219",
	"./UOB.svg": "818f",
	"./VIB.svg": "5888",
	"./VIETBANK.svg": "56f4",
	"./VIETCOMBANK.svg": "549e",
	"./VIETINBANK.svg": "876b",
	"./VPBANK.svg": "8735",
	"./VPBANK1.svg": "4e09",
	"./WOORIBANK.svg": "ef0e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f7a6";